import React from "react";
import Hero from "../components/Hero";
import HODLVaults from "../components/HODLVaults/HODLVaults";
import Layout from "../components/layout";

const IndexPage = () => {
  return (
    <Layout>
      <Hero />
      <HODLVaults />
    </Layout>
  );
};

export default IndexPage;
